export const enum TableContentType {
  Header = "header",
  Canvas = "canvas",
  Body = "body",
}
